export default {
      id: "Icon--check-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "sprite.svg#Icon--check",
      toString: function () {
        return this.url;
      }
    }